<template>
  <div class="body_bm_step">
    <index-header></index-header>
    <div class="_wrapper">
      <div class="bm_step_box">
        <index-steps :step="2"></index-steps>
        <div class="bm_login_form">
          <h2>开始{{sysName}}</h2>
          <a-form :form="form">

           <!-- 作废字段，暂时不用了
           <a-form-item v-if="studentType === 1" label="户籍类型" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol" :required="true">
              <a-radio-group v-decorator="['studentHouseType', {initialValue: 1}]">
                <a-radio :value="1">城市居民</a-radio>
                <a-radio :value="2">生态移民</a-radio>
              </a-radio-group>
            </a-form-item>
            -->

            <!--<a-form-item v-if="studentType === 2" label="办理类型" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol" :required="true">-->
              <!--<a-radio-group v-decorator="['studentApplyType', {initialValue: 1}]">-->
                <!--<a-radio :value="1">材料办理</a-radio>-->
                <!--<a-radio :value="2">积分办理</a-radio>-->
              <!--</a-radio-group>-->
            <!--</a-form-item>-->

            <a-form-item :label="studentTypeName+'姓名'" style="padding-bottom: 15px;" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol" :required="true">
              <a-input size="large" placeholder="请输入姓名" v-decorator="['studentName', {
                validateTrigger: 'blur',
                rules: [{
                  required: true,
                  message: '姓名不能为空'
                }]
              }]"/>
            </a-form-item>

            <a-form-item :label="studentTypeName+'身份证号'" style="padding-bottom: 15px;" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol" :required="true">
              <a-input size="large" placeholder="请输入身份证号" v-decorator="['idCard', {
                validateTrigger: 'blur',
                rules: [{
                  required: true,
                  message: '身份证号不能为空'
                },{
                  pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
                  message: '身份证号格式错误'
                }]
              }]"/>
            </a-form-item>

            <!-- <a-form-item v-if="studentType === 1" label="手机号码" style="padding-bottom: 15px;" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol" :required="true">
              <a-input size="large" placeholder="不能为空" v-decorator="['guardianMobile', {
                rules: [{
                  required: true,
                  message: '手机号码不能为空'
                },{
                  pattern: /(^1[3|4|5|7|8|9]\d{9}$)|(^09\d{8}$)/,
                  message: '手机号码格式错误'
                }]
              }]"/>
            </a-form-item> -->

            <a-form-item :wrapper-col="formItemLayout.submitWrapperCol" style="padding: 20px 0;">
              <a class="sx-btn sx-btn-blue" href="javascript:void(0)" @click="handleSubmit">下一步</a>
            </a-form-item>
          </a-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import IndexCommon from './mixins/index_common';
  import PageBmLogin from './mixins/page_bm_login';

  import IndexHeader from './components/IndexHeader';
  import IndexSteps from './components/IndexSteps';

  const formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 10 },
    submitWrapperCol: { span: 12, offset: 8 }
  };

  export default {
    mixins: [IndexCommon, PageBmLogin],
    components: { IndexHeader, IndexSteps },
    data() {
      return {
        form: this.$form.createForm(this),
        formItemLayout
      };
    },
    created() {
    },
    methods: {
      handleSubmit() {
        this.form.validateFields(err => {
          if (!err) {
            let formVal = this.form.getFieldsValue();
            // 默认取1 材料办理
            formVal.studentApplyType=1;
            this.ajaxCheckIdCard({
              signupNoticeId: this.signupNoticeId,
              idCard: formVal['idCard']
            }, formVal);
          }
        });
      }
    }
  };
</script>

<style lang="stylus" scoped>
  .bm_login_form {
    padding 10px 40px 30px
    h2 {
      padding 40px 0 20px
      text-align center
      color #175375
      font-size 28px
      border-bottom 1px solid #e7e7e7
      margin-bottom 40px
    }
  }
</style>
